import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Lector } from "./lector";
import { EstatusDescargaZE } from "./status";
import { DescargaZEGuiasEdit, paramsDescargaZE } from "./multiselector/edit";

type Entity = models.DescargaZEDTO;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class DescargaZEForm extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    value = (x: Props) => x.value;
    idCarga = createSelectorRx(this.value, value => value.IdRegistro);
    idChoferZE = createSelectorRx(this.value, value => value.IdChoferZE);
    idVehiculo = createSelectorRx(this.value, value => value.IdVehiculoZE);

    get rules(): validation.Rules<Entity> {
        return {
            IdChoferZE: validation.required,
            IdVehiculoZE: validation.required
        };
    }

    private onSeleccionarGuias = async () => {
        var idGuiasIncluidas = this.props.value.IdGuiasIncluidas || [];
        var idVehiculoZE = this.props.value.IdVehiculoZE;
        const params = { IdGuiasYaIncluidas: idGuiasIncluidas, IdVehiculoZE: idVehiculoZE } as paramsDescargaZE
        const result = await this.modals.showModal(DescargaZEGuiasEdit, params, []);
        if (result.result) {
            var idDescargaZE = this.props.value.IdRegistro;
            await resources.DescargaZE.IncluirGuiasSeleccionadas(result.value, idDescargaZE);
        }
    }

    render() {
        const { value, nuevo } = this.props;
        const getField = this.getField;
        const Chofer = getField(selectores.ChoferZE);
        const Vehiculo = getField(selectores.VehiculoZE);

        return (
            <div>
                <kea.Title titulo="Descarga de zona extendida" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <kea.Number label="Folio:" value={value.Folio} readonly />
                ])}

                {
                    kea.autogrid(6, [
                        <Chofer field="IdChoferZE" label="Chofer" readonly />
                    ])
                }
                {
                    kea.autogrid(6, [
                        <Lector idDescarga={value.IdRegistro} />,
                        /*
                        <div style={{ marginTop: "2%" }}>
                            <kea.Button style="primary" onClick={this.onSeleccionarGuias} children="Seleccionar guías" />
                        </div>
                        */
                    ])
                }
                {
                    !nuevo &&
                    <EstatusDescargaZE value={value.IdRegistro} />
                }
                {this.modals.component}
            </div >);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/edit/form.tsx